


















import { Vue, Component } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import IconFrance from '../components/icons/IconFrance.vue';
import IconEnglish from '../components/icons/IconEnglish.vue';
import IconSwitzerland from '../components/icons/IconSwitzerland.vue';
import IconGermany from '../components/icons/IconGermany.vue';
import IconItaly from '../components/icons/IconItaly.vue';
import IconSpain from '../components/icons/IconSpain.vue';
import IconBelgium from '../components/icons/IconBelgium.vue';
import IconDenmark from '../components/icons/IconDenmark.vue';
import IconNetherlands from '../components/icons/IconNetherlands.vue';
import IconSweden from '../components/icons/IconSweden.vue';

interface Language {
  code: string;
  label: string;
  icon: any;
}

@Component({
  components: {
    Multiselect,
    IconFrance,
    IconEnglish,
    IconSwitzerland,
    IconGermany,
    IconItaly,
    IconSpain,
    IconBelgium,
    IconDenmark,
    IconNetherlands,
    IconSweden },
  },
)
export default class LanguageSelector extends Vue {
  public languageList: Language[] = [
    {code: 'en', label: 'English', icon: IconEnglish},
    {code: 'de', label: 'Deutsch', icon: IconSwitzerland},
    {code: 'fr', label: 'Français', icon: IconFrance},
    {code: 'de', label: 'Deutsch', icon: IconGermany},
    {code: 'it', label: 'Italiano', icon: IconItaly},
    {code: 'es', label: 'Español', icon: IconSpain},
    {code: 'da', label: 'Dansk', icon: IconDenmark},
    {code: 'nl', label: 'Nederlands', icon: IconNetherlands},
    {code: 'nl', label: 'Nederlands', icon: IconBelgium},
    {code: 'sv', label: 'Svenska', icon: IconSweden},
  ];
  public selectedLang: any = this.languageList.find((lang: Language) => (lang.code === this.$store.state.partner.lang));

  public onChange(lang: Language) {
    if (lang) {
      this.$store.dispatch('changeLanguage', lang.code);
    }
  }
}
